import React, { useState } from 'react';
import {
  View,
  Text,
  TextInput,
  StyleSheet,
  TouchableOpacity,
  SafeAreaView,
  Platform,
  Image,
  KeyboardAvoidingView,
  ScrollView,
  Linking,
} from 'react-native';
import { COLORS } from '../../theme/themeTokens';
import BackButton from '../../components/UIComponents/BackButton';

let persistedLoginInput = '';
const FONTS = {
  title: Platform.select({
    ios: 'HelveticaNeue',
    android: 'sans-serif',
  }),
  body: Platform.select({
    ios: 'System',
    android: 'sans-serif',
  }),
};

interface ForgotPasswordScreenProps {
  onBack: () => void;
}

export const ForgotPasswordScreen: React.FC<ForgotPasswordScreenProps> = ({
  onBack,
}) => {
  const [loginInput, setLoginInput] = useState(persistedLoginInput);

  const handleSendRequest = () => {
    const subject = encodeURIComponent(`Forgot your password, User: ${loginInput}`);
    Linking.openURL(`mailto:support@l2io.ai?subject=${subject}`).then(() => {
      onBack();
    });
  };

  return (
    <SafeAreaView style={styles.container}>
      {/* Header */}
      <BackButton onPress={onBack} style={{ paddingHorizontal: 20, paddingTop: 20, marginBottom: 0 }} />

      {/* Content */}
      <KeyboardAvoidingView
        style={styles.keyboardAvoid}
        behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
      >
        <ScrollView
          contentContainerStyle={styles.scrollContent}
          keyboardShouldPersistTaps="handled"
          showsVerticalScrollIndicator={false}
        >
          {/* Icon */}
          <Image
            source={require('../../assets/forgot-password-logo.png')}
            style={styles.icon}
            resizeMode="contain"
          />

          {/* Title */}
          <Text style={styles.title}>Forgot your password?</Text>

          {/* Description */}
          <Text style={styles.description}>
            Enter your login and submit a request via email. Our team will contact you.
          </Text>
          <View style={styles.formSection}>
            <View style={styles.inputWrapper}>
              <TextInput
                style={styles.input}
                placeholder="Login"
                placeholderTextColor={COLORS.blueSteel}
                value={loginInput}
                onChangeText={setLoginInput}
                autoCapitalize="none"
                autoCorrect={false}
              />
            </View>
            {/* Send a request Button */}
            <TouchableOpacity
              style={[styles.loginButton, !loginInput.trim() && styles.loginButtonDisabled]}
              onPress={handleSendRequest}
              disabled={!loginInput.trim()}
            >
              <Text style={styles.loginButtonText}>Send a request by e-mail</Text>
            </TouchableOpacity>
          </View>
        </ScrollView>
      </KeyboardAvoidingView>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: COLORS.white,
  },
  keyboardAvoid: {
    flex: 1,
  },
  scrollContent: {
    flexGrow: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 40,
    paddingTop: 20,
    paddingBottom: 100,
  },
  icon: {
    width: 60,
    height: 80,
    marginBottom: 32,
  },
  title: {
    fontFamily: FONTS.title,
    fontSize: 26,
    fontWeight: '500',
    color: COLORS.brandOrange,
    textAlign: 'center',
    marginBottom: 16,
  },
  description: {
    fontFamily: FONTS.body,
    fontSize: 18,
    lineHeight: 26,
    color: COLORS.deepNavy,
    textAlign: 'center',
  },
   inputWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    borderWidth: 1,
    borderColor: COLORS.borderMuted,
    borderRadius: 8,
    height: 56,
    paddingHorizontal: 16,
    backgroundColor: COLORS.white,
  },
  input: {
      flex: 1,
      fontFamily: FONTS.body,
      fontSize: 18,
      color: COLORS.deepNavy,
      height: '100%',
    },
    loginButton: {
    backgroundColor: COLORS.brandOrange,
    borderRadius: 8,
    height: 52,
    justifyContent: 'center',
    alignItems: 'center',
  },
  formSection: {
    width: '100%',
    gap: 16,
    marginTop: 24,
  },
  loginButtonText: {
    lineHeight: 22,
    fontFamily: 'Inter',
      color: COLORS.white,
    fontSize: 16,
    fontWeight: '500',
    },
  loginButtonDisabled: {
    opacity: 0.4,
  },
});

export default ForgotPasswordScreen;

